import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getSubCategoryByCategory,
  getCategoryData,
} from "../apiCalls/category";
import color from "../assets/data/color";
import size from "../assets/data/size";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import Products from "../components/Products";
import ShopFilters from "../components/Shop/ShopFilters";
import { fetchProductByCategory } from "../apiCalls/product";
import Loading from "../components/UIElements/Loading";

const CategoryPage = () => {
  const location = useLocation();
  const categoryId = location.pathname.split("/")[2];

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedSize, setSelectedSize] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);


  const { categoryProducts, isFetching } = useSelector(
    (state) => state.products
  );
  const dispatch = useDispatch();

  console.log(categoryProducts, "prod list", isFetching);

  const [products, setProducts] = useState(categoryProducts);

  const [catName, setCatName] = useState("");
  const [sorting, setSort] = useState("default");

  useEffect(() => {
    fetchProductByCategory(dispatch, categoryId);
    // console.log(categoryId, "cat id");
    // setProducts(categoryProducts);
  }, [dispatch, categoryId]);

  const [categories, setCategories] = useState([]);

  const fetchSubCategories = async () => {
    let { data: res } = await getSubCategoryByCategory(categoryId);
    console.log(res.data, "Category res daa");
    if (res.data) {
      setCategories(res.data);
    }
  };

  const getCatData = async () => {
    let res = await getCategoryData(categoryId);
    console.log(res.data, "Category res daa");
    if (res.data.status) {
      console.log(res.data.data.categoryname, "cat data");
      setCatName(res.data.data.categoryname);
    }
  };

  useEffect(() => {
    fetchSubCategories();
    getCatData();
    // fetchProducts();
  }, []);


  const sortProducts = (e) => {
    let newsortData;
    setSort(e.target.value);
    console.log(sorting);
    if (e.target.value === "a-z") {
      newsortData = products.slice().sort((a, b) => {
        return a.title.localeCompare(b.title);
      });
      setProducts(newsortData);
    }
    if (e.target.value === "z-a") {
      newsortData = products.slice().sort((a, b) => {
        return b.title.localeCompare(a.title);
      });
      setProducts(newsortData);
    }
    if (e.target.value === "low") {
      newsortData = products.slice().sort((a, b) => {
        return a.price - b.price;
      });
      setProducts(newsortData);
    }
    if (e.target.value === "high") {
      newsortData = products.slice().sort((a, b) => {
        return b.price - a.price;
      });
      setProducts(newsortData);
    }
  };

    // handle category checkbox change
    const handleCategoryChange = (category) => {
      console.log(category, "cat checked");
      const updatedCategories = [...selectedCategory];
      if (updatedCategories.includes(category)) {
        updatedCategories.splice(updatedCategories.indexOf(category), 1);
      } else {
        updatedCategories.push(category);
      }
      setSelectedCategory(updatedCategories);
    };
  
    // Handle size checkbox change
    const handleSizeChange = (size) => {
      const updatedSizes = [...selectedSize];
      if (updatedSizes.includes(size)) {
        updatedSizes.splice(updatedSizes.indexOf(size), 1);
      } else {
        updatedSizes.push(size);
      }
      setSelectedSize(updatedSizes);
    };
  
    // Handle color checkbox change
    const handleColorChange = (color) => {
      const updatedColors = [...selectedColor];
      if (updatedColors.includes(color)) {
        updatedColors.splice(updatedColors.indexOf(color), 1);
      } else {
        updatedColors.push(color);
      }
      setSelectedColor(updatedColors);
    };

    const filteredProducts = products.filter((product) => {
      if (
        (selectedCategory.length === 0 ||
          selectedCategory.some((category) =>
            product.subCategories.map((c) => c).includes(category)
          )) &&
        (selectedSize.length === 0 ||
          selectedSize.some((size) => product.size.includes(size))) &&
        (selectedColor.length === 0 ||
          selectedColor.some((color) => product.color.includes(color)))
      ) {
        return true;
      }
      return false;
    });

    useEffect(() => {
      // setProducts();
    }, [sorting]);

  return (
    <>
      <Breadcrumb
        activeName={`${catName}`}
        middleName={"Shop"}
        middleUrl={"/products"}
      />
      <section className="product-list">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="product-list-data">
                <div className="product-filters">
                  <div className="filter-container">
                    <div className="filter">
                      <select onChange={sortProducts} value={sorting}>
                        <option value="default">Default</option>
                        <option value="low">Price (Low to High)</option>
                        <option value="high">Price (High to Low)</option>
                        <option value="a-z">Alphabet A-Z</option>
                        <option value="z-a">Alphabet Z-A</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="product-listing">
                <ShopFilters
                    categoryList={categories}
                    color={color}
                    size={size}
                    handleCategoryChange={handleCategoryChange}
                    handleSizeChange={handleSizeChange}
                    handleColorChange={handleColorChange}
                    selectedCategory={selectedCategory}
                    selectedSize={selectedSize}
                    selectedColor={selectedColor}
                  />
                  {isFetching && (
                   <Loading />
                  )}
                  {!isFetching && <Products products={filteredProducts} /> }
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CategoryPage;


{/* <Products products={filteredProducts} /> */}